// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "vendors" + "-" + "9263964e4f48ebc05c7b" + ".js";
};